import { MARKETPLACE_AI_COURSES_SEARCH_URL } from '@/config/weblinks'
import { UserAuth } from '@/shared/components/UserAuth'
import { Typography } from '@/shared/components/ui/typography'
import React from 'react'
import { Link } from 'react-router-dom'
import { MydraDuoLogo } from './MydraDuoLogo'
import { NavMenu } from './NavMenu'

type HeaderProps = {
  hideUserAuth?: boolean
  hideLinks?: boolean
}

const links = [
  {
    label: 'Pricing',
    href: '/plans',
  },
  {
    label: 'AI Learning',
    href: MARKETPLACE_AI_COURSES_SEARCH_URL,
    target: '_blank',
  },
]

export const Header: React.FC<HeaderProps> = ({ hideUserAuth, hideLinks }) => {
  return (
    <header className="relative flex h-16 shrink-0 items-center justify-between px-8 py-2.5 text-sm font-medium max-md:max-w-full max-md:px-5">
      <nav className="my-auto flex items-center gap-[40px_48px] self-stretch leading-none tracking-[-0.24px] text-black">
        <Link to="/">
          <MydraDuoLogo height={26} />
        </Link>
        {!hideLinks && (
          <div className="my-auto hidden items-center gap-6 self-stretch md:flex">
            {links.map((link) => (
              <Link to={link.href} key={link.href} target={link.target}>
                <Typography variant="body2" className="font-medium">
                  {link.label}
                </Typography>
              </Link>
            ))}
          </div>
        )}
      </nav>
      <div className="flex items-center gap-2">
        {!hideUserAuth && <UserAuth />}
        <NavMenu className="md:hidden" links={links} />
      </div>
    </header>
  )
}
